import axios, { AxiosRequestConfig } from "axios";
import { getCurrentSelection } from "./user.service";
import { useNavigate } from "react-router-dom";

type ResponseType = 'JSON' | 'TEXT' | 'BLOB';

const axiosWrapper = axios.create({
  timeout: 60000
});

const MAX_RETRIES = 3;

function getCustomHeader(respType?: ResponseType): AxiosRequestConfig {
  const token = localStorage.getItem('accessToken');
  const headers = {
    'Content-Type': respType === 'TEXT' ? 'text/html; charset=utf-8' : 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Accept': 'application/json',
    'x-api-key': '452c61b1-aea8-4d7f-9999-553ea091eb37'
  };

  if (token) {
    //@ts-ignore
    headers['authorization'] = `Bearer ${token}`;
    //@ts-ignore
    headers['x-asset-ref'] = getCurrentSelection().id;
  }
  const config: AxiosRequestConfig = { headers };

  if (respType === 'BLOB')
    config.responseType = 'blob';

  return config;
}

axiosWrapper.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    const navigate = useNavigate();

    if (error.response?.status === 401 || error.response?.status === 403) {
      navigate('/logout');
      return;
    }

    if (!config.metadata)
      config.metadata = { retryCount: 0 };

    if (config.metadata.retryCount < MAX_RETRIES && (!error.response || error.response.status >= 500)) {
      config.metadata.retryCount++;
      return axiosWrapper(config);
    }

    return Promise.reject({ code: 'ERROR', message: error.message });
  }
);

export async function axiosGet<T>(path: string, respType?: ResponseType): Promise<T> {
  try {
    const response = await axiosWrapper.get(path, getCustomHeader(respType));
    return response.data;
  } catch (error: any) {
    throw new Error(error.message || "Unknown error. Contact admin.");
  }
}

export async function axiosPost<T>(path: string, reqBody: Object = {}, respType?: ResponseType): Promise<T> {
  try {
    const response = await axiosWrapper.post(path, reqBody, getCustomHeader(respType));
    return response.data;
  } catch (error: any) {
    throw new Error(error.message || "Unknown error. Contact admin.");
  }
}

export async function axiosPut<T>(path: string, reqBody: Object = {}, respType?: ResponseType): Promise<T> {
  try {
    const response = await axiosWrapper.put(path, reqBody, getCustomHeader(respType));
    return response.data;
  } catch (error: any) {
    throw new Error(error.message || "Unknown error. Contact admin.");
  }
}

export async function axiosDelete<T>(path: string, respType?: ResponseType): Promise<T> {
  try {
    const response = await axiosWrapper.delete(path, getCustomHeader(respType));
    return response.data;
  } catch (error: any) {
    throw new Error(error.message || "Unknown error. Contact admin.");
  }
}